module.exports = require("./smn.js");